import { ReactNode, TableHTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react'

export const Table = ({ children, className = '', ...props }: TableHTMLAttributes<HTMLTableElement> & { children: ReactNode }) => (
    <div className="overflow-x-auto rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
        <table className={`w-full border-collapse text-left ${className}`} {...props}>
            {children}
        </table>
    </div>
)

export const TableHead = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
    <thead className={`border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 ${className}`}>{children}</thead>
)

export const TableBody = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
    <tbody className={`divide-y divide-slate-200 dark:divide-slate-700 ${className}`}>{children}</tbody>
)

export const TableRow = ({ children, className = '', ...props }: { children: ReactNode; className?: string } & React.HTMLAttributes<HTMLTableRowElement>) => (
    <tr className={`transition-colors hover:bg-slate-50 dark:hover:bg-slate-800 ${className}`} {...props}>
        {children}
    </tr>
)

export const Th = ({ children, className = '', align, ...props }: ThHTMLAttributes<HTMLTableCellElement> & { children?: ReactNode }) => (
    <th
        className={`px-4 py-2.5 text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400 ${align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-left'} ${className}`}
        {...props}
    >
        {children}
    </th>
)

export const Td = ({ children, className = '', align, ...props }: TdHTMLAttributes<HTMLTableCellElement> & { children?: ReactNode }) => (
    <td className={`px-4 py-2.5 text-sm ${align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : ''} ${className}`} {...props}>
        {children}
    </td>
)
